import React from "react";

import {
  CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import CardElementContainer from "./CardElementContainer";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#32325d",
      fontFamily: "Avenir, sans-serif",
      fontSmoothing: "antialiased",
      lineHeight: "26px",
      borderRadius: "10px",
      border: "1px solid",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#e51c23",
      iconColor: "#e51c23",
    },
  },
};
var cardBrandToPfClass = {
  visa: "pf-visa",
  mastercard: "pf-mastercard",
  amex: "pf-american-express",
  discover: "pf-discover",
  diners: "pf-diners",
  jcb: "pf-jcb",
  unknown: "pf-credit-card",
};

const NewCBForm = () => {
  const setBrandIcon = (brand) => {
    var brandIconElement = document.getElementById("brand-icon");
    var pfClass = "pf-credit-card";
    if (brand in cardBrandToPfClass) {
      pfClass = cardBrandToPfClass[brand];
    }
    for (var i = brandIconElement.classList.length - 1; i >= 0; i--) {
      brandIconElement.classList.remove(brandIconElement.classList[i]);
    }
    brandIconElement.classList.add("pf");
    brandIconElement.classList.add(pfClass);
  };
  const cardElementChange = (e) => {
    if (e.brand) {
      setBrandIcon(e.brand);
    }
  };
  return (
    <div className="row">
      <div className="col-12 mb-3">
        <CardElementContainer label="Numéro de carte" icon="fa fa-credit-card">
          <CardNumberElement
            options={CARD_ELEMENT_OPTIONS}
            onChange={cardElementChange}
          />
          <span
            className="brand d-center"
            style={{
              position: "absolute",
              bottom: 23,
              right: 10,
              fontSize: 22,
              color: "#a0aed3",
            }}
          >
            <i className="pf pf-credit-card" id="brand-icon"></i>
          </span>
        </CardElementContainer>
      </div>
      <div className="col-6">
        <CardElementContainer label="Date d'expiration" icon="fa fa-calendar">
          <CardExpiryElement options={CARD_ELEMENT_OPTIONS} />
        </CardElementContainer>
      </div>
      <div className="col-6">
        <CardElementContainer label="CVC" icon="fa fa-lock">
          <CardCvcElement options={CARD_ELEMENT_OPTIONS} />
        </CardElementContainer>
      </div>
    </div>
  );
};

export default NewCBForm;
